import { translate } from '~/assets/javascript/localization/Localization';
import AxiosWrapper from "~/assets/javascript/AxiosWrapper";
import { getField, updateField } from "vuex-map-fields";

const getEventsUrl = "/data_api/events/users";

AxiosWrapper.init();

const getDefaultState = () => ({
  events: [],
  sortOrder: [
    {
      field: 'created_at',
      sortField: 'created_at',
      direction: 'desc'
    }
  ],
  loadingMessage: translate('no_data_available'),
  loading: false,
  page: 1,
  itemsPerPage: 75,
  totalPages: 1,
  totalEvents: 0
})

export const state = getDefaultState

export const getters = {
  getField
}

export const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  init(state, getRequestedData) {
    state.events = getRequestedData.events;
    state.totalPages = getRequestedData.total_pages;
    state.totalEvents = getRequestedData.total;
    state.itemsPerPage = parseInt(getRequestedData.items_per_page, 10);
    if (getRequestedData.page) {
      state.page = parseInt(getRequestedData.page, 10);
    }
  },
  removeEventAtIndex(state, index) {
    state.events.splice(index, 1);
  },
  updateField
}

export const actions = {
  async init({commit, dispatch}) {
    commit("resetState")
    dispatch("fetchPage", { page: 1, itemsPerPage: 75 });
  },
  async fetchPage({commit}, { page, itemsPerPage }) {
    commit("updateField", { path: "loading", value: true });
    commit("updateField", { path: "loadingMessage", value: translate('loading') });
    commit("updateField", { path: "page", value: page });
    commit("updateField", { path: "itemsPerPage", value: itemsPerPage });
    AxiosWrapper.get(getEventsUrl, { params: { page, items_per_page: itemsPerPage } }).then((response) => {
      commit("init", response.data);
      commit("updateField", { path: "loadingMessage", value: translate('no_data_available') });
      commit("updateField", { path: "loading", value: false });
    });
  },
  deleteAllEvents({commit, state}) {
    if (confirm(translate("delete_confirm"))) {
      commit("updateField", { path: "loading", value: true });
      AxiosWrapper.delete('/data_api/events/users/delete_all').then(() => {
        commit("updateField", { path: "loading", value: false });
        commit("updateField", { path: "events", value: []})
      });
    }
  },
  clearEvent({commit, state}, {clear_path, id}) {
    if (confirm(translate("delete_confirm"))) {
      commit("updateField", { path: "loading", value: true });

      var eventsObject = state.events.find((element) => {
        return element.id == id;
      });

      let index = state.events.findIndex(element => element.id == eventsObject.id );

      AxiosWrapper.delete(clear_path).then(() => {
        commit("updateField", { path: "loading", value: false });
        commit('removeEventAtIndex', index)
      })
    }
  }
}